import { render, staticRenderFns } from "./ImportClientList.vue?vue&type=template&id=d13c517a&scoped=true&"
import script from "./ImportClientList.vue?vue&type=script&lang=js&"
export * from "./ImportClientList.vue?vue&type=script&lang=js&"
import style0 from "./ImportClientList.vue?vue&type=style&index=0&id=d13c517a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13c517a",
  null
  
)

export default component.exports